import React from 'react';
import { Building2, PieChart, Edit3, TrendingUp, BarChart3, Gavel, Megaphone, Globe } from 'lucide-react';

const FeatureCard = ({ icon: Icon, title, description, iconColor }) => {
    return (
        <div className="group relative flex flex-col items-center transform transition-transform duration-300 hover:-translate-y-2">
            {/* Hover Effect Background */}
            <div className="absolute inset-0 bg-[#2A2E35] opacity-0 group-hover:opacity-100 rounded-lg transition-opacity duration-300 -z-10 shadow-lg"></div>

            {/* Icon Container */}
            <div className="relative">
                <div
                    className="flex items-center justify-center transform transition-transform duration-300 group-hover:scale-110">
                    <div
                        className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 flex items-center justify-center bg-gray-800/40 rounded-2xl backdrop-blur-sm">
                        <Icon className="w-8 h-8 text-[#FFC107]" strokeWidth={1.5}/>
                    </div>
                </div>
            </div>

            {/* Text Content */}
            <div className="mt-8 text-center p-4 transition-all duration-300 group-hover:translate-y-1">
                <h3 className="text-lg font-bold mb-3 text-white">{title}</h3>
                <p className="text-base text-gray-400 leading-relaxed transition-colors duration-300 group-hover:text-gray-300">
                    {description}
                </p>
            </div>

            {/* Hover Glow Effect */}
            <div
                className="absolute -inset-0.5 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-lg opacity-0 group-hover:opacity-10 blur transition duration-300"></div>
        </div>

    // <div className="relative w-80 p-6 bg-gray-800/20 rounded-xl backdrop-blur-sm">
    //     <div
    //         className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 flex items-center justify-center bg-gray-800/40 rounded-2xl backdrop-blur-sm">
    //         <Icon className="w-8 h-8 text-[#FFC107]" strokeWidth={1.5}/>
    //     </div>
    //     <div className="mt-8 text-center">
    //         <h3 className="text-lg font-semibold mb-2">{title}</h3>
    //         <p className="text-sm text-gray-300">{description}</p>
    //     </div>
    // </div>
)
    ;
};

const FeatureGrid = () => {
    const features = [
        {
            icon: Building2,
            title: "БАЙГУУЛЛАГА",
            description: "Байгууллагын бүтэц, орон тоо салбар нэгж түүнд хамаарах ерөнхий мэдээлэл,хууль эрх зүй, мэдээ мэдээллийг удирдан зохион байгуулах боломжтой."
        },
        {
            icon: PieChart,
            title: "ТӨСӨВ",
            description: "Төсвийн түүхэн мэдээллийг цуглуулж, нэгтгэн, ангилж төсвийн захирагчийн бүх түвшинд харах боломжийг бүрдүүлсэнээр албан хаагч нэг тоо, нэг мэдээлэл дээр ажиллах боломжоор хангагдсан."
        },
        {
            icon: Edit3,
            title: "ТӨСВИЙН САНАЛ",
            description: "Төсвийг доороос дээш боловсруулах зарчмын дагуу бүх шатны төсвийн захирагч нарын төсвийн төсөл боловсруулах процессыг бүрэн автоматжуулсан цэс."
        },
        {
            icon: TrendingUp,
            title: "ТӨСВИЙН ХУВААРЬ",
            description: "Төсвийн захирагч нар батлагдсан төсвөө хуваарилах, сар, улирлын хуваарьт өөрчлөлт оруулан шийдвэрлэх үйл ажиллагааг бүрэн автоматжуулсан модуль."
        },
        {
            icon: BarChart3,
            title: "СТАТИСТИК",
            description: "Салбарын тоон мэдээллийг боловсруулан дүн шинжилгээ хийж оновчтой, үр дүнтэй шийдвэр гаргахад шаардлагатай мэдээллийг нэг цонхноос авах боломжийг бүрдүүлсэн."
        },
        {
            icon: Gavel,
            title: "ЭРХ ЗҮЙН АКТ",
            description: "Эрхлэх асуудлын хүрээнд дагаж мөрдөх хууль, тогтоомжуудыг эрх зүйн актын болон баримт бичгийн аль ч төрлөөр харах боломжтой."
        },
        {
            icon: Megaphone,
            title: "МЭДЭЭ, МЭДЭЭЛЭЛ",
            description: "Нэгдсэн систем танд салбарын болон байгууллагын үйл ажиллагаатай холбоотой өдөр тутмын шинэ соргог мэдээ, мэдээллийг цаг алдалгүй хүргэнэ.​ "
        },
        {
            icon: Globe,
            title: "OPENWEB",
            description: "Яам түүний харьяа агентлаг, байгууллагуудад өмчийн хэлбэрээс үл хамааран нэг стандарт бүхий хаанаас ч хандах боломжтой “OpenWeb” буюу тусгайлсан вэбсайтыг хөгжүүлэн нэвтрүүлсэн.​"
        }
    ];

    return (
        <div
            className="min-h-screen min-w-screen h-full flex flex-col md:flex-row items-center px-4 md:px-24 py-8 md:py-16 overflow-auto">
            {/* Mobile Title */}
            <div className="md:hidden mb-8 w-full">
                <h2 className="text-3xl font-bold text-center">МОДУЛЬ</h2>
            </div>

            <div className="relative flex flex-col md:flex-row flex-1 w-full">
                {/* Desktop Vertical Title */}
                <div className="hidden md:block absolute top-1/2 -translate-y-1/2 items-center justify-center">
                    <h2 className="text-4xl font-bold transform -rotate-90 whitespace-nowrap origin-center">
                        МОДУЛЬ
                    </h2>
                </div>

                {/* Grid Container */}
                <div className="flex-1 md:ml-24 w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-12">
                        {features.map((feature, index) => (
                            <FeatureCard
                                key={index}
                                icon={feature.icon}
                                title={feature.title}
                                description={feature.description}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureGrid;